const forwardRequestPanel = {
  errors: {
    loadFailed: "Failed to load forward targets",
    forwardFailed: "Failed to forward request",
    inviteFailed: "Failed to send the invitation",
  },
  loading: "Loading recipients…",
  empty: "No data uploaders or PIs are available to forward this request to.",
  intro:
    "Select one or more recipients. Check an organisation to select all of its members, or expand it to pick specific people.",
  expand: {
    collapse: "Collapse",
    expand: "Expand",
  },
  role: {
    pi: "PI",
    uploader: "Uploader",
  },
  alreadyForwarded: "Already forwarded",
  noOrganisation: "No organisation",
  notesPlaceholder: "Note for the recipient (optional)…",
  invite: {
    heading: "Invite a new data supplier",
    emailPlaceholder: "Email address (required)",
    namePlaceholder: "Name (optional)",
    orgPlaceholder: "Organisation (optional)",
    hint: "They get an upload link for this request. The note above is included in the invitation email.",
    sending: "Sending…",
    sendInvitation: "Send invitation",
    inviteSomeone: "Invite someone not listed…",
  },
  back: "Back",
  forward: {
    forwarding: "Forwarding…",
    forward: "Forward",
    forwardToCount_one: "Forward to {{count}} recipient",
    forwardToCount_other: "Forward to {{count}} recipients",
  },
  cancel: "Cancel",
  selectAtLeastOne: "Select at least one recipient",
};

export default forwardRequestPanel;
